export default function SiteOnLoading(){
    return (
        <div>Loading...</div>
    )
}